import { useIsMounted } from '@toss/react';

import { useVerifyAuthor } from '@/api';

export type CheckMyQuizStatus = 'unknown' | 'isMe' | 'isOther';

export const useCheckMyQuiz = (
  id: string,
  enabled?: boolean,
): { isLoading: boolean; meStatus: CheckMyQuizStatus } => {
  const isMounted = useIsMounted();

  const { data, isLoading, isSuccess } = useVerifyAuthor(
    {
      id,
    },
    { query: { enabled: isMounted && enabled, refetchOnWindowFocus: false } },
  );
  return {
    isLoading,
    meStatus:
      isLoading || !isSuccess
        ? 'unknown'
        : data?.data.isAuthor
        ? 'isMe'
        : 'isOther',
  };
};
